import {AfterViewInit, Directive, ElementRef, Input, Renderer2} from '@angular/core';

@Directive({
  selector: '[appScrollAnimate]'
})
export class ScrollAnimateDirective implements AfterViewInit {
  @Input() direction: 'vertical' | 'left' | 'right' = 'vertical';

  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {
  }

  ngAfterViewInit() {
    const native = this.el.nativeElement;

    this.renderer.addClass(native, 'transition-all');
    this.renderer.addClass(native, 'duration-700');
    this.renderer.addClass(native, 'opacity-0');

    switch (this.direction) {
      case 'left':
        this.renderer.addClass(native, 'translate-x-[-40px]');
        break;
      case 'right':
        this.renderer.addClass(native, 'translate-x-[40px]');
        break;
      case 'vertical':
      default:
        this.renderer.addClass(native, 'translate-y-20');
        break;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.renderer.removeClass(native, 'opacity-0');
          this.renderer.addClass(native, 'opacity-100');

          this.renderer.removeClass(native, 'translate-x-[-40px]');
          this.renderer.removeClass(native, 'translate-x-[40px]');
          this.renderer.removeClass(native, 'translate-y-20');
        } else {
          this.renderer.removeClass(native, 'opacity-100');
          this.renderer.addClass(native, 'opacity-0');

          switch (this.direction) {
            case 'left':
              this.renderer.addClass(native, 'translate-x-[-40px]');
              break;
            case 'right':
              this.renderer.addClass(native, 'translate-x-[40px]');
              break;
            case 'vertical':
            default:
              this.renderer.addClass(native, 'translate-y-20');
              break;
          }
        }
      },
      {threshold: 0.1}
    );

    observer.observe(native);
  }
}
